import type { VideoStatus } from 'models';
import { apiClient, routes } from 'common/services';
import type { VideoContentObjectDataObject } from 'models/service';

// TODO: unify naming
type UpdateStatusVariables = {
  data: {
    video: {
      status: VideoStatus;
    };
  };
  id: string;
};

export const updateStatus = async ({ data, id }: UpdateStatusVariables) =>
  apiClient.post<VideoContentObjectDataObject>(routes.videos.updateStatus(id), data);
